const workingHourInDay = 8;

export { workingHourInDay };
